import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faShieldAlt } from '@fortawesome/free-solid-svg-icons';
import { Button, Card, Col, Container, Form, Row } from '@themesberg/react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../../context/AdminAuthContext';
import { Routes } from '../../routes';
import { AlertMessage } from '../../components/PageHeader';

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const location = useLocation();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const from =
    (location.state && location.state.from && location.state.from.pathname) || Routes.AdminTenants.path;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(username.trim(), password);
      // Full navigation so admin pages remount with token already in localStorage
      // (avoids a race where the first fetch runs before auth state settles).
      window.location.assign(from);
    } catch (err) {
      setError(err.message || 'Admin login failed');
      setLoading(false);
    }
  };

  return (
    <main>
      <Container className="py-5">
        <Row className="justify-content-center">
          <Col xs={12} md={8} lg={6}>
            <div className="d-flex align-items-center justify-content-between mb-4">
              <Link to={Routes.Welcome.path} className="d-flex align-items-center text-decoration-none">
                <FontAwesomeIcon icon={faShieldAlt} className="text-primary me-2" />
                <span className="fw-bold text-primary">Flowfence</span>
              </Link>
              <Link to={Routes.Login.path} className="text-gray small">
                <FontAwesomeIcon icon={faAngleLeft} className="me-1" />
                Workspace sign in
              </Link>
            </div>
            <Card border="light" className="shadow-sm">
              <Card.Body className="p-4 p-lg-5">
                <h3 className="mb-2">Platform admin</h3>
                <p className="text-gray mb-4">Sign in to view all tenants.</p>
                <AlertMessage variant="danger" message={error} onClose={() => setError('')} />
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label>Username</Form.Label>
                    <Form.Control
                      required
                      autoComplete="username"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      placeholder="admin"
                    />
                  </Form.Group>
                  <Form.Group className="mb-4">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                      required
                      type="password"
                      autoComplete="current-password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="Password"
                    />
                  </Form.Group>
                  <Button variant="primary" type="submit" className="w-100" disabled={loading}>
                    {loading ? 'Signing in…' : 'Sign in'}
                  </Button>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </main>
  );
}
